import React from 'react';

export function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center p-4" role="status">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500" />
      <span className="sr-only">Loading...</span>
    </div>
  );
}